export default __webpack_public_path__ + "static/media/notebook-64.d33a2ede.svg";